import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { GenericListColumn, GenericListComponent, GenericListState } from '@motivforce/mx-library-angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-custom-list',
  templateUrl: './custom-list.component.html',
  styleUrls: ['./custom-list.component.scss'],
})
export class CustomListComponent {
  private _genericList: GenericListComponent;

  @ViewChild(GenericListComponent, { static: true })
  set genericList(value: GenericListComponent) {
    this._genericList = value;
    this.applyCustomItemRenderers();
  }

  get genericList(): GenericListComponent {
    return this._genericList;
  }

  private _dataProvider: any[] = [];

  private _customItemRenderers: Record<string, TemplateRef<any>> = {};

  @Input() set customItemRenderers(value: Record<string, TemplateRef<any>>) {
    this._customItemRenderers = value ?? {};
    this.applyCustomItemRenderers();
  }

  @Input() columnsProvider: GenericListColumn[] = [];
  @Input() noResultsMessageDisplayKey = `&nbsp;&nbsp;&nbsp;&nbsp;${this.translate.instant('No records found.')}`;
  @Input() rowHeight = '40px';
  @Input() totalCount = 0;
  @Input() itemSelectableFunction: (item: any) => boolean;
  @Input() itemHighlightableFunction: (item: any) => boolean;

  itemsPerPageDisplayKey = `${this.translate.instant('Items per page')}:`;
  entriesDisplayKey = '';

  @Output() stateChanged: EventEmitter<GenericListState> = new EventEmitter();

  constructor(protected translate: TranslateService) {}

  get selectedItems() {
    return this.genericList.selectedItems;
  }

  private applyCustomItemRenderers(): void {
    if (!this._genericList) {
      return;
    }

    Object.entries(this._customItemRenderers).forEach(([fieldName, template]) => {
      this._genericList.customItemRenderers[fieldName] = template;
    });
  }

  @Input()
  get dataProvider(): any[] {
    return this._dataProvider;
  }

  set dataProvider(dataProvider: any[]) {
    this._dataProvider = dataProvider;
  }
}
